import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiButton } from '@elastic/eui';
import NavButtons from 'components/Downloads/Outdoor_Cameras/NavButtons';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "IN-5907 HD Downloads",
  "path": "/Downloadbereich/Aussenkameras/IN-5907_HD/",
  "dateChanged": "2017-12-12",
  "author": "Mike Polinowski",
  "excerpt": "INSTAR Firmware, WebUI und Dokumentations-Downloads",
  "image": "./P_SearchThumb_IN-5907HD_Downloads.png",
  "social": "/images/Search/P_SearchThumb_IN-5907HD_Downloads.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_P-Downloads_white.webp",
  "chapter": "Downloads"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Downloadbereich - IN-5907 HD' dateChanged='2018-09-20' author='Mike Polinowski' tag='INSTAR IP Camera' description='Software Downloads und Handbücher für Ihre INSTAR Produkte' image='/images/Search/P_SearchThumb_IN-5907HD_Downloads.png' twitter='/images/Search/P_SearchThumb_IN-5907HD_Downloads.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Downloads/Outdoor_Cameras/IN-5907_HD/' locationFR='/fr/Downloads/Outdoor_Cameras/IN-5907_HD/' crumbLabel="IN-5907" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <h1 {...{
      "id": "downloads",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#downloads",
        "aria-label": "downloads permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Downloads`}</h1>
    <h2 {...{
      "id": "outdoor-cameras",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#outdoor-cameras",
        "aria-label": "outdoor cameras permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Outdoor Cameras`}</h2>
    <h2 {...{
      "id": "in-5907-hd-downloads",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#in-5907-hd-downloads",
        "aria-label": "in 5907 hd downloads permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`IN-5907 HD Downloads`}</h2>
    {
      /* TOC */
    }
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#software-installation-wizard"
        }}>{`Software Installation Wizard`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#anleitungen"
        }}>{`Anleitungen`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#schnellinstallation"
            }}>{`Schnellinstallation`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#updates-kamera-software"
        }}>{`Updates Kamera-Software`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#firmware"
            }}>{`Firmware`}</a>
            <ul parentName="li">
              <li parentName="ul"><a parentName="li" {...{
                  "href": "#download"
                }}>{`Download`}</a></li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    {
      /* /TOC */
    }
    <h2 {...{
      "id": "software-installation-wizard",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#software-installation-wizard",
        "aria-label": "software installation wizard permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Software Installation Wizard`}</h2>
    <p>{`Jedes INSTAR Produkt wird mit einer Installations-CD ausgeliefert. Die CD beinhaltet einen Installationsassistenten der Sie durch die Einrichtung Ihres neuen INSTAR Produktes leitet. Der Installationsassistent kann auch direkt aufgerufen werden indem Sie unten auf den Link klicken und somit die CD online öffnen. Der Assistent enthält alle Informationen und aktuelle Download-Links die Sie für die Installation benötigen.`}</p>
    <p>{`Die Software CD beinhaltet einen HTML Einrichtungsassistenten der Sie durch die benötigten Einstellungen leitet und Ihnen die aktuellen Downloadlinks für Ihr INSTAR Produkt anzeigt.`}</p>
    <p><strong parentName="p">{`Schnellinstallations-Assistent`}</strong>{`: Der Assistent leitet Sie durch die wichtigsten Schritte um Ihr INSTAR Produkt in Betrieb zu nehmen.`}</p>
    <p><strong parentName="p">{`Software Installation`}</strong>{`: Sie finden Download Links sofern Ihr INSTAR Produkt zusätzliche Software benötigt. Sie werden durch alle Schritte geleitet nachdem Sie den Download und die Installation abgeschlossen haben.`}</p>
    <p><strong parentName="p">{`Firmware Updates`}</strong>{`: INSTAR bietet in regelmäßigen Abständen Firmware und WebUI Updates für seine Produkte an. Weiter unten finden Sie die aktuellen Versionen der Firmware und WebUI die Sie auf Ihre INSTAR Kamera aufspielen können.`}</p>
    <OutboundLink href="https://install.instar.com/" target="_blank" rel="noopener noreferrer" mdxType="OutboundLink"><EuiButton fill mdxType="EuiButton">Start Installation</EuiButton></OutboundLink>
    <h2 {...{
      "id": "anleitungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#anleitungen",
        "aria-label": "anleitungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Anleitungen`}</h2>
    <h3 {...{
      "id": "schnellinstallation",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#schnellinstallation",
        "aria-label": "schnellinstallation permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Schnellinstallation`}</h3>
    <p>{`Die Bedienungsanleitung beinhaltet ausführliche Informationen zu allen Funktionen der Kamera.`}</p>
    <p><strong parentName="p">{`Schnellinstallation`}</strong>{`: Der Bereich Schnellinstallation beinhaltet eine Übersicht über alle nötigen Schritte um Ihre Kamera per LAN Kabel, WLAN und über das Internet zu installieren.`}</p>
    <p><strong parentName="p">{`Die Weboberfläche`}</strong>{`: Der Bereich Weboberfläche gibt Ihnen eine Übersicht über alle Funktionen der Kamera und wie man diese konfiguriert wenn man mit dem Webbrowser auf die Kamera zugreift.`}</p>
    <p><strong parentName="p">{`Technische Spezifikationen`}</strong>{`: Sie finden eine Liste aller technischen Spezifikationen Ihrer INSTAR IP Kamera.`}</p>
    <p><strong parentName="p">{`Produkt Funktionen und Sicherheitswarnungen`}</strong></p>
    <p><strong parentName="p">{`Windows Software, Smartphone Apps und Video Streaming`}</strong></p>
    <p><strong parentName="p">{`Kamera Reset, Objektivjustage, Garantie und Entsorgung`}</strong></p>
    <p><strong parentName="p">{`FAQ Fragen und Antworten`}</strong></p>
    <Link to="https://wiki.instar.com/dl/IN-5907HD/QuickInstallation-IN-5907HD_EN-DE.pdf" target="_blank" rel="noopener noreferrer" mdxType="Link"><EuiButton fill mdxType="EuiButton">Anleitung </EuiButton></Link>
    <h2 {...{
      "id": "updates-kamera-software",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#updates-kamera-software",
        "aria-label": "updates kamera software permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Updates Kamera-Software`}</h2>
    <h3 {...{
      "id": "firmware",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#firmware",
        "aria-label": "firmware permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Firmware`}</h3>
    <p>{`Sie finden hier immer die neueste Version und alle Vorgängerversionen der Firmware für Ihre Kamera. Sofern Sie ein Update der WebUI planen, stellen Sie immer sicher, dass Sie die neueste Version der Firmware installiert haben. In den meisten Fällen erfordern die neuen Funktionen in der Weboberfläche (WebUI) auch die neueste Firmware. Für Informationen wie Sie die Firmware updaten schauen Sie bitte `}<a parentName="p" {...{
        "href": "/de/Schnell_Installation/WebUI_und_Firmware_Upgrade/"
      }}>{`hier`}</a>{`.`}</p>
    <p><strong parentName="p">{`Wichtig`}</strong>{`: Entpacken Sie nach dem Download bitte die *.ZIP Datei. Beachten Sie auch das Sie zuerst die neueste Firmware installieren und erst dann die WebUI.`}</p>
    <h4 {...{
      "id": "download",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h4" {...{
        "href": "#download",
        "aria-label": "download permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Download`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.69_WebUI_1.22(758)_update.zip"
        }}>{`FW 3.1.2.69 WebUI 1.22 (758)`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.69_WebUI_1.22(758)_update.zip"
        }}>{`PoE FW 3.1.2.69 WebUI 1.22 (758)`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Aktualisierung der P2P Firmware`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.69_WebUI_1.22(756)_update.zip"
        }}>{`FW 3.1.2.69 WebUI 1.22 (756)`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.69_WebUI_1.22(756)_update.zip"
        }}>{`PoE FW 3.1.2.69 WebUI 1.22 (756)`}</a>
        <ul parentName="li">
          <li parentName="ul">{`P2P Dienst aktualisiert`}</li>
          <li parentName="ul">{`Texte geändert`}</li>
          <li parentName="ul">{`System Logbuch wird nicht angezeigt /behoben`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.69_WebUI_1.21.(751)_update.zip"
        }}>{`FW 3.1.2.69 WebUI 1.21`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.69_WebUI_1.21.(751)_update.zip"
        }}>{`PoE FW 3.1.2.69 WebUI 1.21`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Alarmvideos bis zu 45 Sekunden`}</li>
          <li parentName="ul">{`Touch-Unterstützung bei den Alarmbereichen`}</li>
          <li parentName="ul">{`Im Logbuch kann beim Login nun die IP-Adresse mit aufgezeichnet werden - Aktivierbar unter Benutzerverwaltung`}</li>
          <li parentName="ul">{`Auslösender Alarmbereich wird bei gekoppeltem Alarm im Log mit verzeichnet`}</li>
          <li parentName="ul">{`Ein PUSH-Test wurde hinzugefügt. Der QR-Code muss in der APP aber zunächst eingescannt werden`}</li>
          <li parentName="ul">{`WLAN- und Netzwerkkonfigurationen können vom Werksreset ausgeschlossen werden`}</li>
          <li parentName="ul">{`CGI-Befehl für eine manuelle Alarmauslösung hinzugefügt - /param.cgi?cmd=pushhostalarm`}</li>
          <li parentName="ul">{`Kamera meldet sich über DHCP mit einzigartigem Hostnamen an`}</li>
          <li parentName="ul">{`Es wurden zudem Funktionalitäten implementiert um Kameras zu retten, bei denen ein fehlerhaftes Update vorangegangen ist. Um Sicher zu gehen, dass diese Funktionalitäten vorhanden sind, ist ein Downgrade auf ältere Versionen als die 1.21 (751) nicht mehr möglich.`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.68_WebUI_1.20.(736)_update.zip"
        }}>{`FW 3.1.2.68 WebUI 1.20`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.68_WebUI_1.20.(736)_update.zip"
        }}>{`PoE FW 3.1.2.68 WebUI 1.20`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Vereinfachte 1-Klick-Update-Methode`}</li>
          <li parentName="ul">{`Offline Update über PKG-Datei weiterhin möglich`}</li>
          <li parentName="ul">{`Alarmbereiche lassen sich in 2 Gruppen nach Zeiten konfigurieren`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.66_WebUI_1.19.(653)_update.zip"
        }}>{`FW 3.1.2.66 WEBUI 1.19`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.66_WebUI_1.19.(653)_update.zip"
        }}>{`PoE FW 3.1.2.66 WEBUI 1.19`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Verbesserung bei P2P`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.66_WebUI_1.18(653)_update.zip"
        }}>{`FW 3.1.2.66 WEBUI 1.18`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.66_WebUI_1.18(653)_update.zip"
        }}>{`PoE FW 3.1.2.66 WEBUI 1.18 *`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Problem bei P2P behoben`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.66_WebUI_1.17.(634)_update.zip"
        }}>{`FW 3.1.2.66 WEBUI 1.17`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.66_WebUI_1.17.(634)_update.zip"
        }}>{`PoE FW 3.1.2.66 WEBUI 1.17 *`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Problem bei automatischer Sommer-/Winterzeitumstellung behoben`}</li>
          <li parentName="ul">{`Problem behoben wodurch der Alarmton bei der IN-6014HD nicht deaktivierbar war`}</li>
          <li parentName="ul">{`Neue Validierung integriert bei Eingabefeldern`}</li>
          <li parentName="ul">{`Sicherheitslücke geschlossen`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.64_WebUI_1.16.(620)_update.zip"
        }}>{`FW 3.1.2.64 WEBUI 1.16`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.64_WebUI_1.16.(620)_update.zip"
        }}>{`PoE FW 3.1.2.64 WEBUI 1.16 *`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Problem mit P2P Verbindung behoben`}</li>
          <li parentName="ul">{`Verbesserung im Bezug auf die P2P Verbindungsgeschwindigkeit`}</li>
          <li parentName="ul">{`Neue INSTAR Cloud Aufnahmeplattform ab sofort verfügbar`}</li>
          <li parentName="ul">{`Benutzerdefinierter NTP Zeitserver ist jetzt möglich`}</li>
          <li parentName="ul">{`Problem bei FTP Upload behoben`}</li>
          <li parentName="ul">{`Problem mit Benutzername und Passwortauthentifizierung bei MJPEG Stream und snap.jpg behoben`}</li>
          <li parentName="ul">{`Problem behoben das die Kamera bei einer Portänderung neu startet`}</li>
          <li parentName="ul">{`Sonderzeichen Problem bei WLAN, DDNS, FTP und Cloud Kennwörtern behoben`}</li>
          <li parentName="ul">{`Anpassungen der Strings / Bezeichnungen`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.64_WebUI_1.15(617)_update.zip"
        }}>{`FW 3.1.2.64 WEBUI 1.15`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.64_WebUI_1.15(617)_update.zip"
        }}>{`PoE FW 3.1.2.64 WEBUI 1.15 *`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Bugfixes`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.64_WebUI_1.14(604)_update.zip"
        }}>{`FW 3.1.2.64 WEBUI 1.14`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.64_WebUI_1.14(604)_update.zip"
        }}>{`PoE FW 3.1.2.64 WEBUI 1.14 *`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Problem mit P2P Verbindung behoben`}</li>
          <li parentName="ul">{`Benutzerdefinierter NTP Zeitserver`}</li>
          <li parentName="ul">{`Problem bei FTP Upload behoben`}</li>
          <li parentName="ul">{`Problem bei Cloud Aktivierung behoben`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.63_WebUI_1.13(586)_update.zip"
        }}>{`FW 3.1.2.63 WEBUI 1.13`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.63_WebUI_1.13(586)_update.zip"
        }}>{`PoE FW 3.1.2.63 WEBUI 1.13 *`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Integration der neuen INSTAR Cloud Plattform`}</li>
          <li parentName="ul">{`LAN und WLAN Mac Adresse werden jetzt beide unter "System - Info" angezeigt (sofern das Kameramodell WLAN hat)`}</li>
          <li parentName="ul">{`Änderung Vorauswahl für GMX`}</li>
          <li parentName="ul">{`Anzeige von LAN und WLAN MAC-Adresse`}</li>
          <li parentName="ul">{`Die Vorauswahl für GMX beim Emailversand wurde von mail.gmx.net auf mail.gmx.de geändert um Problemen mit dem Telekom Speedport zu vermeiden`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.56_WebUI_1.12(555)_update.zip"
        }}>{`FW 3.1.2.56 WEBUI 1.12`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.56_WebUI_1.12(555)_update.zip"
        }}>{`PoE FW 3.1.2.56 WEBUI 1.12 *`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Alarm Server`}</li>
          <li parentName="ul">{`Täglicher zeitgesteuerter Kamera-Neustart`}</li>
          <li parentName="ul">{`Email SMTP Versand ohne Authentifizierung`}</li>
          <li parentName="ul">{`Neuer Installations Wizard`}</li>
          <li parentName="ul">{`User & Gast Accounts können deaktiviert werden`}</li>
          <li parentName="ul">{`Deutscher Syslog`}</li>
          <li parentName="ul">{`Problem mit 'leerem' Kameranamen behoben`}</li>
          <li parentName="ul">{`H264 Video-Support für alle Ports im User- und Gastzugang`}</li>
          <li parentName="ul">{`Problem mit bestimmen Email-Anbietern behoben (z.B. GMX, web.de, Gmail, AOL)`}</li>
          <li parentName="ul">{`Problem behoben das der Alarm Eingang, Audio Alarm und die Bewegungserkennung nicht seperat nutzbar waren wenn aktiviert`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
          <li parentName="ul">{`Kamera Park Position für alle PTZ Modelle`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.45_WebUI_1.11.(431)_update.zip"
        }}>{`FW 3.1.2.45 WEBUI 1.11`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.45_WebUI_1.11.(431)_update.zip"
        }}>{`PoE FW 3.1.2.45 WEBUI 1.11 *`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Neuer h.264 Videostream mittels RTMP Protokoll über den RTMP Port (sh. Netzwerk > IP Konfiguration) mit Flash Plugin Support`}</li>
          <li parentName="ul">{`Zwei unterschiedliche MotionJPEG Stream Varianten`}</li>
          <li parentName="ul">{`Privacy Mask - Festlegen von bis zu 4 Privatbereichen die im Videobild komplett ausgeblendet werden`}</li>
          <li parentName="ul">{`Kameraeinstellungen werden mit dem Update nicht mehr gelöscht`}</li>
          <li parentName="ul">{`h.264 Video Support für Linux mittels Flash`}</li>
          <li parentName="ul">{`Manuelle Aufnahmefunktion auf die integrierte Speicherkarte der Kamera`}</li>
          <li parentName="ul">{`Ordnerstruktur unter FTP`}</li>
          <li parentName="ul">{`Manuelles Öffnen (grau) und Schließen (rot) des Alarm Ausgangs-Relais über die Weboberfläche`}</li>
          <li parentName="ul">{`Kameras können bei WLAN Verbindung mit einem anderen WLAN Verbunden werden`}</li>
          <li parentName="ul">{`Allgemeine Bugfixes und Verbesserungen`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.37_WebUI_1.9.(213)_update.zip"
        }}>{`FW 3.1.2.37 WEBUI 1.9`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.37_WebUI_1.9.(213)_update.zip"
        }}>{`PoE FW 3.1.2.37 WEBUI 1.9 *`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Push Benachrichtigungen sind absofort möglich mit der App InstarVision`}</li>
          <li parentName="ul">{`ActiveX Plugin Support für Chrome und Firefox unter Windows`}</li>
          <li parentName="ul">{`Neue NTP Server`}</li>
          <li parentName="ul">{`Behebung von Problemen mit dem 1und1 Emailserver`}</li>
          <li parentName="ul">{`Neuer INSTAR Emailserver steht zur Auswahl für den Emailversand`}</li>
          <li parentName="ul">{`Ein zweiter Email Empfänger kann eingetragen werden`}</li>
          <li parentName="ul">{`Zeitgesteuerte Aktivierung und Deaktivierung der IR LEDs`}</li>
          <li parentName="ul">{`PTZ Begrenzung (für Kameras mit PTZ)`}</li>
          <li parentName="ul">{`Alarmposition anfahren (für Kameras mit PTZ)`}</li>
          <li parentName="ul">{`Akustisches Alarmsignal bei Bewegungserkennung über Kameralautsprecher bzw. Audio Ausgang`}</li>
          <li parentName="ul">{`automatisierter Test bei WLAN`}</li>
          <li parentName="ul">{`Automatische Prüfung der SD Karte`}</li>
          <li parentName="ul">{`Verbesserungen, Bugfixes und TYPOS`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.31_WebUI_1.6.(126)_update.pkg.zip"
        }}>{`FW 3.1.2.31 WEBUI 1.6`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.31_WebUI_1.6.(126)_update.pkg.zip"
        }}>{`PoE FW 3.1.2.31 WEBUI 1.6 *`}</a>
        <ul parentName="li">
          <li parentName="ul">{`SMTP Server Info für 1und1`}</li>
          <li parentName="ul">{`Bugfix Audio-Output bei P2P`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.31_WebUI_1.5.(121)_update.zip"
        }}>{`FW 3.1.2.31 WEBUI 1.5`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.31_WebUI_1.5.(121)_update.zip"
        }}>{`PoE FW 3.1.2.31 WEBUI 1.5 *`}</a>
        <ul parentName="li">
          <li parentName="ul">{`Bugfix: Verlorenes Gateway`}</li>
          <li parentName="ul">{`neue SMTP Verschlüsselungen`}</li>
          <li parentName="ul">{`Aktualisierung Logbuch`}</li>
          <li parentName="ul">{`kleinere Bugfixes`}</li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907_FW_3.1.2.30_WebUI_1.4.(104)_update.pkg.zip"
        }}>{`FW 3.1.2.30 WEBUI 1.4`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://wiki.instar.com/dl/IN-5907HD/IN-5907-PoE_FW_3.1.2.30_WebUI_1.4.(104)_update.pkg.zip"
        }}>{`PoE FW 3.1.2.30 WEBUI 1.4 *`}</a>
        <ul parentName="li">
          <li parentName="ul">{`mehr unterstützte E-Mail Provider`}</li>
          <li parentName="ul">{`Kompatibilität mit IE11`}</li>
          <li parentName="ul">{`Videos per Zeitplan auf SD`}</li>
          <li parentName="ul">{`UI in Französisch und Chinesisch`}</li>
        </ul>
      </li>
    </ul>
    <div className="warningbox">
  (*) Diese Version darf nur auf einem 5907 Power-over-Ethernet und nicht auf einem 5907 WLAN installiert werden.
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      